import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateString',
  standalone: true
})
export class DisparosPipe implements PipeTransform {

  transform(value: string, limit: number): string {
    if(!value) return value;

    return value.length > limit ? value.substring(0, limit) : value;
  }

}
